<!-- eslint-disable no-unused-expressions -->
<!-- eslint-disable no-unused-expressions -->
<!-- eslint-disable vue/max-attributes-per-line -->
<template>
  <div>
    <!-- Form Modal -->
    <b-modal id="modal-society-form" ref="myModal" centered no-close-on-backdrop no-close-on-esc size="md" @ok="submit">
      <!-- Custom Modal Header -->
      <template #modal-header="{ close }">
        <!-- Emulate built in modal header close button action -->
        <h5 v-if="society.id === null">
          Register Society
        </h5>
        <h5 v-else>
          Edit Society
        </h5>

        <feather-icon class="ml-4 pr-0 cursor-pointer" icon="XIcon" size="16" @click="close()" />
      </template>

      <!-- Custom Modal Footer -->
      <template #modal-footer="{ ok, cancel }">
        <b-button size="sm" variant="primary" :disabled="saving" @click="ok()">
          <b-spinner v-if="saving" small class="mr-1" label="Small Spinner" />
          <span v-if="!saving">Save</span>
          <span v-if="saving">Saving...</span>
        </b-button>
        <b-button size="sm" variant="outline-secondary" @click="cancel()">
          Cancel
        </b-button>
      </template>

      <!-- Data Form in Modal Body -->
      <template #default="{ }">
        <validation-observer ref="dataForm" #default="{ invalid }">
          <b-form ref="form" @submit.stop.prevent="handleCreate">
            <b-row>
              <b-col cols="12" class="mb-md-0 mb-2">
                <location-filters
                  size="sm"
                  align="vertical"
                  @filter="changeFilter"
                />
                <small v-if="serverErrors && serverErrors.location_id" class="text-danger">{{ serverErrors.location_id[0] }}</small>
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="12" md="3">
                <b-form-group label-for="code" label="Code">
                  <validation-provider #default="{ errors }" name="Code" rules="">
                    <b-form-input
                      id="code"
                      v-model="society.code"
                      name="code"
                      :state="errors.length > 0 ? false : null"
                      size="sm"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                    <small v-if="serverErrors && serverErrors.code" class="text-danger">{{ serverErrors.code[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col cols="9">
                <b-form-group label-for="name" label="Name">
                  <validation-provider #default="{ errors }" name="name" rules="required">
                    <b-form-input
                      id="name"
                      v-model="society.name"
                      name="name"
                      :state="errors.length > 0 ? false : null"
                      size="sm"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                    <small v-if="serverErrors && serverErrors.name" class="text-danger">{{ serverErrors.name[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row v-for="(acc, index) in society.accounts" :key="index" class="mb-2">
              <b-col cols="12">
                <p class="text-center font-weight-bold text-uppercase">
                  {{ acc.currency === 'usd' ? 'Dollar Account' : 'Shilling Account' }}
                </p>
              </b-col>

              <b-col cols="6">
                <b-form-group :label-for="acc.currency+'_bank_id'" label="Bank">
                  <b-form-select :id="acc.currency+'_bank_id'" v-model="acc.bank_id" size="sm" @change="changeBank(index, $event)">
                    <b-form-select-option :value="null">
                      -- Select --
                    </b-form-select-option>
                    <b-form-select-option v-for="bank in banks" :key="bank.id" :value="bank">
                      {{ bank.name }}
                    </b-form-select-option>
                  </b-form-select>
                </b-form-group>
              </b-col>

              <b-col cols="6">
                <b-form-group :label-for="acc.currency+'_branch_id'" label="Branch">
                  <b-form-select
                    :id="acc.currency+'_branch_id'"
                    v-model="acc.branch_id" size="sm"
                    @change="changeBranch($event)"
                  >
                    <b-form-select-option :value="null">
                      Select...
                    </b-form-select-option>
                    <b-form-select-option v-for="branch in branches" :key="branch.id" :value="branch.id">
                      {{ branch.name }}
                    </b-form-select-option>
                  </b-form-select>
                </b-form-group>
              </b-col>

              <b-col cols="6">
                <b-form-group :label-for="acc.currency+'_account_number'" label="Account Number">
                  <validation-provider #default="{ errors }" :name="`Account Number (${acc.currency.toUpperCase()})`">
                    <b-form-input
                      :id="acc.currency+'_account_number'"
                      v-model="acc.account_number"
                      :name="`account_number_${index}`"
                      :state="errors.length > 0 ? false : null"
                      size="sm"
                    />
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col cols="6">
                <b-form-group :label-for="acc.currency+'_account_name'" label="Account Name">
                  <validation-provider #default="{ errors }" :name="`Account Name (${acc.currency.toUpperCase()})`">
                    <b-form-input
                      :id="acc.currency+'_account_name'"
                      v-model="acc.account_name"
                      :name="`account_name_${index}`"
                      :state="errors.length > 0 ? false : null"
                      size="sm"
                    />
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <span>Operates In</span>
              <hr>
              <b-col cols="12" class="mb-md-0 mb-2">
                <administrative-location-filters
                  size="sm"
                  align="horizontal"
                  @filter="changeAdministrativeFilter"
                />
                <small v-if="serverErrors && serverErrors.administrative_id" class="text-danger">{{ serverErrors.administrative_id[0] }}</small>
              </b-col>
            </b-row>

          </b-form>
        </validation-observer>
        <!-- <b-card>
            {{ society }}
        </b-card> -->
      </template>
    </b-modal>
    <!-- ./Form Modal -->

    <!-- Filters -->
    <b-card no-body>
      <b-card-header class="pb-50">
        <h5>Filter Location</h5>
      </b-card-header>
      <b-card-body>
        <b-row>
          <b-col cols="12" md="12">
            <location-filters
              size="sm"
              align="horizontal"
              @filter="changeFilter"
            />
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
    <!-- ./Filters -->

    <!-- Table Container Card -->
    <b-card no-body class="mb-0">
      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->
          <b-col cols="12" md="6" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
            <label>Show</label>
            <v-select v-model="perPage" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :options="perPageOptions"
                      :clearable="false" class="per-page-selector d-inline-block mx-50 select-size-sm"
            />
            <label>entries</label>
          </b-col>
          <!-- ./Per Page -->

          <!-- Search -->
          <b-col cols="12" md="6">
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input v-model="searchQuery" class="d-inline-block mr-1" placeholder="Search..." size="sm" />
              <b-button
                variant="primary"
                size="sm"
                @click="invokeCreateForm()"
              >
                <span class="text-nowrap">Register Society</span>
              </b-button>
            </div>
          </b-col>
          <!-- ./Search -->
        </b-row>
        <!-- ./Table Top -->
      </div>

      <!-- Table -->
      <b-table
        ref="records"
        striped
        hover
        small
        class="position-relative"
        :items="fetch"
        responsive
        :fields="columns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="No records found"
        :sort-desc.sync="isSortDirDesc"
      >
        <!-- Column: Serail Number -->
        <template #cell(sno)="row">
          {{ row.index + from }}
        </template>

        <!-- Column: User -->
        <template #cell(user)="data">
          <b-media vertical-align="center">
            <template #aside>
              <b-avatar size="32" :src="data.item.avatar" :text="avatarText(data.item.fullName)"
                        :variant="`light-${resolveUserRoleVariant(data.item.role)}`"
                        :to="{ name: 'apps-users-view', params: { id: data.item.id } }"
              />
            </template>
            <b-link :to="{ name: 'apps-users-view', params: { id: data.item.id } }"
                    class="font-weight-bold d-block text-nowrap"
            >
              {{ data.item.fullName }}
            </b-link>
            <small class="text-muted">@{{ data.item.username }}</small>
          </b-media>
        </template>

        <!-- Column: Role -->
        <template #cell(role)="data">
          <div class="text-nowrap">
            <feather-icon :icon="resolveUserRoleIcon(data.item.role)" size="18" class="mr-50"
                          :class="`text-${resolveUserRoleVariant(data.item.role)}`"
            />
            <span class="align-text-top text-capitalize">{{ data.item.role }}</span>
          </div>
        </template>

        <!-- Column: Status -->
        <template #cell(status)="data">
          <b-badge pill :variant="`light-${resolveStatusVariant(data.item.status)}`" class="text-capitalize">
            <span v-if="data.item.status === 0">Closed</span>
            <span v-else-if="data.item.status === 1">Active</span>
            <span v-else>Re-opened</span>
          </b-badge>
        </template>

        <template #cell(code)="data">
          <span class="text-nowrap">
            {{ data.value }}
          </span>
        </template>

        <template #cell(administrative_location)="data">
          <span v-if="data.item.administrative_location !== null">
            {{ data.item.administrative_location.name }} {{ data.item.administrative_location.level.name }}
          </span>
        </template>

        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <b-dropdown variant="link" no-caret :right="$store.state.appConfig.isRTL">

            <template #button-content>
              <feather-icon icon="MoreVerticalIcon" size="16" class="align-middle text-body" />
            </template>

            <b-dropdown-item :to="{ path: 'societies/' + data.item.id }" @click="storeItem(data.item)">
              <feather-icon icon="EyeIcon" />
              <span class="align-middle ml-50">View</span>
            </b-dropdown-item>

            <b-dropdown-item @click="invokeUpdateForm(data.item)">
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">Edit</span>
            </b-dropdown-item>

            <b-dropdown-item @click="remove(data.item.id)">
              <feather-icon icon="TrashIcon" />
              <span class="align-middle ml-50">Delete</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>
      </b-table>

      <!-- Table Footer -->
      <div class="mx-2 mb-2">
        <b-row>
          <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-start">
            <span class="text-muted">Showing {{ from }} to {{ to }} of {{ totalRecords }} entries</span>
          </b-col>
          <!-- Pagination -->
          <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">
            <b-pagination v-model="currentPage" :total-rows="totalRecords" :per-page="perPage" first-number last-number
                          class="mb-0 mt-1 mt-sm-0" prev-class="prev-item" next-class="next-item"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>

    </b-card>
    <!-- ./Table Container Card -->
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
    BCard, BCardHeader, BCardBody, BRow, BCol, BForm, BFormGroup, BFormInput, BFormCheckbox, BFormSelect, BFormSelectOption, BModal, VBModal, BButton, BTable,
    BBadge, BDropdown, BDropdownItem, BPagination, BSpinner,
} from 'bootstrap-vue'
import LocationFilters from '@core/components/cromis/filters/LocationFilters.vue'
import AdministrativeLocationFilters from '@core/components/cromis/filters/AdministrativeLocationFilters.vue'
import { required, integer } from '@validations'
import store from '@/store'
import { ref, onUnmounted, onMounted } from '@vue/composition-api'
import vSelect from 'vue-select'
import societiesStoreModule from '@/views/cromis/society/societiesStoreModule'
import useSocietiesList from '@/views/cromis/society/useSocietiesList'

export default {
    components: {
        BCard,
        BCardHeader,
        BCardBody,
        BRow,
        BCol,
        BForm,
        BFormGroup,
        BFormInput,
        BFormCheckbox,
        BFormSelect,
        BFormSelectOption,
        BModal,
        BButton,
        BSpinner,
        BTable,
        BBadge,
        BDropdown,
        BDropdownItem,
        BPagination,

        vSelect,
        ValidationProvider,
        ValidationObserver,
        LocationFilters,
        AdministrativeLocationFilters,
    },
    directives: {
        'b-modal': VBModal,
    },
    props: {},
    setup(props, context) {
        const dataForm = ref(null)
        const myModal = ref(null)
        const saving = ref(false)
        const serverErrors = ref(null)

        const banks = ref([])
        const branches = ref([])

        const society = ref({
            id: null,
            name: null,
            location_id: null,
            administrative_id: null,
            code: null,
            accounts: [
                {
                    branch_id: null,
                    bank_id: null,
                    account_number: null,
                    account_name: null,
                    currency: 'tzs',
                },
                {
                    branch_id: null,
                    bank_id: null,
                    account_number: null,
                    account_name: null,
                    currency: 'usd',
                },
            ],

        })

        // Map currencies
        const currencyMap = {
            TZS: 'tzs',
            USD: 'usd',
        }

        const CROMIS_SOCIETY_STORE_MODULE_NAME = 'cromis-society'

        // Register module
        if (!store.hasModule(CROMIS_SOCIETY_STORE_MODULE_NAME)) store.registerModule(CROMIS_SOCIETY_STORE_MODULE_NAME, societiesStoreModule)

        // UnRegister on leave
        onUnmounted(() => {
            if (store.hasModule(CROMIS_SOCIETY_STORE_MODULE_NAME)) store.unregisterModule(CROMIS_SOCIETY_STORE_MODULE_NAME)
        })

        onMounted(async () => {
            await store.dispatch('cromis-society/banks')
                .then(response => {
                    banks.value = response.data.banks
                })
                .catch(error => {
                    console.log('got error', error)
                })
        })

        const storeItem = item => {
            localStorage.setItem('selectedSociety', JSON.stringify(item))
        }

        const changeFilter = async filteredValue => {
            society.value.location_id = filteredValue != null ? filteredValue.id : null
            locationFilter.value = filteredValue != null ? filteredValue.id : null
        }

        const changeAdministrativeFilter = async filteredValue => {
            society.value.administrative_id = filteredValue != null ? filteredValue.id : null
            administrativeFilter.value = filteredValue != null ? filteredValue.id : null
        }

        const isAddNewUserSidebarActive = ref(false)

        const {
            fetch,
            columns,
            perPage,
            currentPage,
            totalRecords,
            from,
            to,
            meta,
            perPageOptions,
            searchQuery,
            sortBy,
            isSortDirDesc,
            records,
            refetch,

            // Filters
            locationFilter,
            administrativeFilter,
            locationType,

            // UI
            // resolveUserRoleVariant,
            // resolveUserRoleIcon,
            resolveStatusVariant,
        } = useSocietiesList()

        // Methods
        const resetForm = () => {
            society.value.id = null
            society.value.name = null
            society.value.code = null
            society.value.branch_id = null
            society.value.bank_id = null
            society.value.account_number = null
            society.value.account_name = null
            society.value.location_id = null
            society.value.administrative_id = null
        }

        const changeBank = async (index, bank) => {
            console.log(bank)
            branches.value = bank.branches
            // society.value.account[index].bank_id = bank.id
        }

        const changeBranch = async event => {
            console.log(event)
        }

        const invokeUpdateForm = item => {
            serverErrors.value = null

            const getLocationId = () => (selections.value.length ? selections.value.at(-1).model.id : null)

            const defaultCurrencies = ['tzs', 'usd']
            const accounts = []

            // If there are existing accounts
            if (item.accounts && item.accounts.length > 0) {
                const addedCurrencies = new Set()

                item.accounts.forEach((acc, index) => {
                    const bank = banks.value.find(b => b.id === acc.bank?.id) || acc.bank || null
                    const branch = bank?.branches?.find(br => br.id === acc.branch?.id)

                    const currency = acc.currency?.abbreviation
                        ? currencyMap[acc.currency.abbreviation] || acc.currency.abbreviation.toLowerCase()
                        : ''

                    addedCurrencies.add(currency)

                    accounts.push({
                        bank_id: bank,
                        branch_id: branch?.id || null,
                        account_number: acc.number || '',
                        account_name: acc.name || '',
                        currency,
                    })

                    if (bank) {
                        changeBank(index, bank)
                    }
                })

                // Add missing currency entry
                defaultCurrencies.forEach(cur => {
                    if (!addedCurrencies.has(cur)) {
                        accounts.push({
                            bank_id: null,
                            branch_id: null,
                            account_number: null,
                            account_name: null,
                            currency: cur,
                        })
                    }
                })
            } else {
                // No accounts, add both tzs and usd entries
                defaultCurrencies.forEach(cur => {
                    accounts.push({
                        bank_id: null,
                        branch_id: null,
                        account_number: null,
                        account_name: null,
                        currency: cur,
                    })
                })
            }

            society.value = {
                id: item.id,
                location_id: item.location_id,
                administrative_id: item.administrative_id,
                code: item.code,
                name: item.name,
                accounts,
            }

            myModal.value.show()
        }

        const invokeCreateForm = () => {
            society.value.id = null
            society.value.name = null
            society.value.code = null
            // eslint-disable-next-line no-unused-expressions
            society.value.accounts = [
                {
                    branch_id: null,
                    bank_id: null,
                    account_number: null,
                    account_name: null,
                    currency: 'tzs',
                },
                {
                    branch_id: null,
                    bank_id: null,
                    account_number: null,
                    account_name: null,
                    currency: 'usd',
                },
            ],

            society.value.location_id = null
            society.value.administrative_id = null

            myModal.value.show()
        }

        const isFormValid = async () => {
            let isValid = false
            await dataForm.value.validate().then(success => {
                isValid = success
            })

            return isValid
        }

        const submit = bvModalEvt => {
            bvModalEvt.preventDefault()

            serverErrors.value = null
            // Handle form submit
            if (society.value.id === null || society.value.id === 0) handleCreate()
            else handleUpdate(society.value)
        }

        const handleCreate = async () => {
            saving.value = true
            const valid = await isFormValid()

            if (!valid) {
                saving.value = false
                return
            }
            const payload = {
                ...society.value,
                accounts: society.value.accounts.map(acc => ({
                    ...acc,
                    bank_id: acc.bank_id?.id || acc.bank_id, // support both ID or object
                })),
            }

            console.log('Submitting:', payload)

            await store.dispatch('cromis-society/create', payload)
                .then(response => {
                    refetch()
                    saving.value = false

                    myModal.value.hide()

                    context.root.$swal({
                        icon: 'success',
                        text: `Society ${response.data.name} has been saved successfully!`,
                        showConfirmButton: true,
                        timer: 5000,
                        customClass: {
                            confirmButton: 'btn btn-primary',
                        },
                        buttonsStyling: false,
                    })
                })
                .catch(error => {
                    saving.value = false
                    if (error.response.status === 422) {
                        serverErrors.value = error.response.data.errors
                    } else {
                        context.root.$swal({
                            icon: 'error',
                            title: 'Server Error',
                            text: 'Something went wrong. See tech support',
                            showConfirmButton: true,
                            customClass: {
                                confirmButton: 'btn btn-danger',
                            },
                            buttonsStyling: false,
                        })
                    }
                })
        }

        const handleUpdate = async item => {
            saving.value = true
            const valid = await isFormValid()

            if (!valid) {
                saving.value = false
                return
            }

            const payload = {
                ...society.value,
                accounts: society.value.accounts.map(acc => ({
                    ...acc,
                    bank_id: acc.bank_id?.id || acc.bank_id, // support both ID or object
                })),
            }

            await store.dispatch('cromis-society/update', { id: item.id, data: payload })
                .then(response => {
                    saving.value = false

                    refetch()

                    myModal.value.hide()

                    context.root.$swal({
                        icon: 'success',
                        text: `Changes to society ${response.data.name} has been saved successfully!`,
                        showConfirmButton: false,
                        timer: 5000,
                        customClass: {
                            confirmButton: 'btn btn-success',
                        },
                        buttonsStyling: false,
                    })
                })
                .catch(error => {
                    saving.value = false

                    context.root.$swal({
                        icon: 'error',
                        title: 'Server Error',
                        text: 'Something went wrong. See tech support',
                        showConfirmButton: true,
                        customClass: {
                            confirmButton: 'btn btn-danger',
                        },
                        buttonsStyling: false,
                    })
                })
        }

        const remove = async id => {
            await store.dispatch('cromis-society/remove', id)
                .then(response => {
                    refetch()

                    context.root.$swal({
                        icon: 'info',
                        title: 'System Info',
                        text: 'Society has been deleted successfully',
                        showConfirmButton: true,
                        customClass: {
                            confirmButton: 'btn btn-info',
                        },
                        buttonsStyling: true,
                    })
                })
                .catch(error => {
                    context.root.$swal({
                        icon: 'error',
                        title: 'Server Error',
                        text: 'Something went wrong. See tech support',
                        showConfirmButton: false,
                        customClass: {
                            confirmButton: 'btn btn-danger',
                        },
                        buttonsStyling: false,
                    })
                })
        }

        return {
            // Sidebar
            isAddNewUserSidebarActive,

            LocationFilters,
            changeFilter,
            changeAdministrativeFilter,
            fetch,
            columns,
            perPage,
            currentPage,
            totalRecords,
            from,
            to,
            meta,
            perPageOptions,
            searchQuery,
            sortBy,
            isSortDirDesc,
            records,
            refetch,
            banks,
            branches,

            resolveStatusVariant,

            // Filters
            locationFilter,
            locationType,

            // Form Data
            society,

            // Validations
            required,
            integer,

            // Methods and Form refs
            myModal,
            saving,
            serverErrors,
            dataForm,
            resetForm,
            invokeCreateForm,
            invokeUpdateForm,
            isFormValid,
            submit,
            handleCreate,
            handleUpdate,
            remove,
            changeBank,
            changeBranch,
            currencyMap,
            storeItem,
        }
    },
}
</script>

<style lang="scss" scoped>
@import '@core/scss/vue/libs/vue-select.scss';
</style>
